import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1feed6cb"
var script = {}
import style0 from "./App.scss?vue&type=style&index=0&prod&global=true&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports